import { useCallback, useMemo } from 'react';

import { DataStorageQuery } from 'dashboard-services/api/dataStorage';
import Query from 'dashboard-services/api/Query';

import { settingsSeriesActions } from 'actions/series';

import { useQueries } from '@tanstack/react-query';

export default(() => {

  const useKeysForGroups = ({ input, selectedSymbols, getApiConfig, getMetadataFilter = undefined, getSymbolFilter = undefined, getSelect, provider }) => {
    const getQueryBuilder = useCallback(() => new Query.Builder(getApiConfig())
            .withFetching(false)
            .withHeader("Target", provider, true)
          , [getApiConfig, provider]),
          queries = useMemo(() => selectedSymbols.map(s => {
            const filterSymbolObj = getSymbolFilter ? getSymbolFilter(s) : {}
            const filterMetadataObj = getMetadataFilter ? getMetadataFilter(s) : {}
            return { 
              ...DataStorageQuery.QUERIES.getSymbolKeys(
                getQueryBuilder,
                { 
                  groupName: s.groupName || "",
                  query: input ? `*${input}*` :  "*",
                  symbols: filterSymbolObj,
                  size: 100,
                  metadata: true,
                  metadatas: filterMetadataObj,
                  useEs: true,
                  omitRequiredKeys: true,
                  provider
                },
              ),
              select: getSelect
            }
          }), [selectedSymbols, getSymbolFilter, getMetadataFilter, getQueryBuilder, input, provider, getSelect]),
          combine = useCallback(results => ({
            data: settingsSeriesActions.prepareKeysResponse(results.map(result => result.data)),
            isPending: results.some(result => result.isPending),
            isFetching: results.some(result => result.isFetching),
          }), [])
  
    return useQueries({
      queries,
      combine,
    })
  }

  return {
    useKeysForGroups
  }
})()

